import { GetDashboardListResponseBody } from '../../types/generated/dashboards_get.response';
import apiEndpoints from '../../../apiEndpoints';
import { fetcher } from '../../utils/fetchers/fetcher';

export const requestDashboards = (
  token: string | null,
  forceHeader?: string
): Promise<GetDashboardListResponseBody> =>
  fetcher<GetDashboardListResponseBody>(
    apiEndpoints.routes.dashboards,
    'GET',
    token,
    forceHeader
  );
